import styled from 'styled-components'

export const Textarea = styled.textarea`
  width: 100%;
  height: 240px;
`
